import { render } from "./BaseRadioButtonGroup.vue?vue&type=template&id=118b9d3e&scoped=true"
import script from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioButtonGroup.vue?vue&type=script&lang=js"

import "./BaseRadioButtonGroup.vue?vue&type=style&index=0&id=118b9d3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118b9d3e"]])

export default __exports__